import React, { useState } from "react";

// Reemplaza el feo window.confirm() del navegador al avisar retiro — antes de
// avisar hay que estar seguro de que ninguno de estos productos es en
// realidad un activo fijo (esos se etiquetan y entregan por otro camino). Si
// resulta que alguno sí lo es, se marca ahí mismo y se llenan sus datos en
// su pantalla (al volver, la ventana de avisar se abre sola) en vez de tener
// que cancelar y volver a buscar el ítem.
// items: [{ id, descripcion, cantidad }]
// Se pueden marcar uno o varios como activo fijo (o todos de una vez) y al continuar se abre,
// uno tras otro, el formulario para llenar los datos de cada uno.
function ConfirmarNoActivoModal({ items, procesando, onCancelar, onMarcarActivos, onConfirmar }) {
  const [busqueda, setBusqueda] = useState("");
  const [marcados, setMarcados] = useState([]);

  if (!items || items.length === 0) return null;
  const esPlural = items.length > 1;
  const termino = busqueda.trim().toLowerCase();
  const visibles = termino ? items.filter((it) => it.descripcion.toLowerCase().includes(termino)) : items;
  const todosMarcados = marcados.length === items.length;
  const alternar = (id) => setMarcados((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));

  return (
    <div style={styles.overlay} onClick={procesando ? undefined : onCancelar}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.encabezado}>
          <div style={styles.icono}>🏷️</div>
          <div>
            <h3 style={styles.titulo}>
              ¿Estás seguro de que {esPlural ? "estos artículos no forman" : "este artículo no forma"} parte de
              activos fijos?
            </h3>
            <p style={styles.subtitulo}>
              {items.length} producto{esPlural ? "s" : ""} a notificar como {esPlural ? "normales" : "normal"} (no
              etiquetados).
            </p>
          </div>
        </div>

        {items.length > 8 && (
          <input
            type="text"
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            placeholder="🔍 Buscar producto..."
            style={styles.buscador}
          />
        )}

        <div className="table-scroll" style={styles.tablaWrap}>
          <table style={styles.tabla}>
            <thead>
              <tr>
                <th style={{ ...styles.th, width: 40 }}>#</th>
                <th style={styles.th}>Producto</th>
                <th style={{ ...styles.th, textAlign: "center" }}>A notificar</th>
                <th style={{ ...styles.th, textAlign: "center" }}>
                  <label style={{ display: "inline-flex", alignItems: "center", gap: "0.4rem", cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      checked={todosMarcados}
                      disabled={procesando}
                      onChange={() => setMarcados(todosMarcados ? [] : items.map((it) => it.id))}
                    />
                    ¿Es activo fijo? (todos)
                  </label>
                </th>
              </tr>
            </thead>
            <tbody>
              {visibles.map((it) => (
                <tr key={it.id} style={styles.fila}>
                  <td style={{ ...styles.td, color: "#8993a1" }}>{items.indexOf(it) + 1}</td>
                  <td style={{ ...styles.td, fontWeight: 600 }}>{it.descripcion}</td>
                  <td style={{ ...styles.td, textAlign: "center", whiteSpace: "nowrap" }}>
                    <span style={styles.pastilla}>{it.cantidad}</span>
                  </td>
                  <td style={{ ...styles.td, textAlign: "center" }}>
                    <label style={{ display: "inline-flex", alignItems: "center", gap: "0.4rem", cursor: "pointer" }}>
                      <input
                        type="checkbox"
                        checked={marcados.includes(it.id)}
                        disabled={procesando}
                        onChange={() => alternar(it.id)}
                      />
                      <span style={{ fontSize: "0.82rem", color: marcados.includes(it.id) ? "var(--tema-titulo, #0b3c60)" : "#5b6472", fontWeight: 600 }}>
                        Sí, es activo
                      </span>
                    </label>
                  </td>
                </tr>
              ))}
              {visibles.length === 0 && (
                <tr>
                  <td colSpan={4} style={{ ...styles.td, textAlign: "center", color: "#8993a1" }}>
                    Ningún producto coincide con la búsqueda.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <p style={styles.aviso}>
          ⚠️ Si {esPlural ? "alguno es un activo" : "es un activo"}, márcalo con su casilla (o marca todos arriba) y
          toca "Llenar datos del activo": se abrirá la pantalla de cada uno y al terminar regresarás aquí para
          notificar el retiro.
        </p>

        <div style={styles.pie}>
          <button type="button" onClick={onCancelar} disabled={procesando} style={styles.botonCancelar}>
            Cancelar
          </button>
          <button
            type="button"
            onClick={() => onMarcarActivos(marcados)}
            disabled={procesando || marcados.length === 0}
            style={{ ...styles.botonEsActivo, opacity: marcados.length === 0 ? 0.5 : 1 }}
            title="Abre el formulario de datos de los productos marcados como activo fijo"
          >
            📝 Llenar datos del activo{marcados.length > 0 ? ` (${marcados.length})` : ""}
          </button>
          <button
            type="button"
            onClick={() => onConfirmar(items)}
            disabled={procesando || marcados.length > 0}
            style={{ ...styles.botonConfirmar, opacity: marcados.length > 0 ? 0.5 : 1 }}
            title={marcados.length > 0 ? "Hay productos marcados como activo: llena sus datos primero" : ""}
          >
            {procesando ? "Enviando..." : `✓ No ${esPlural ? "son" : "es"} activo${esPlural ? "s" : ""}, continuar`}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(27,42,74,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
    padding: "1rem",
  },
  modal: {
    background: "#fff",
    borderRadius: 16,
    padding: "1.5rem 1.7rem 1.3rem",
    width: "100%",
    maxWidth: 820,
    maxHeight: "92vh",
    overflowY: "auto",
    boxShadow: "0 16px 48px rgba(27,42,74,0.35)",
  },
  encabezado: { display: "flex", gap: "0.9rem", alignItems: "center", marginBottom: "1rem" },
  icono: {
    width: 48,
    height: 48,
    borderRadius: 12,
    background: "var(--tema-titulo, #0b3c60)",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.4rem",
    flexShrink: 0,
  },
  titulo: { margin: 0, fontSize: "1.08rem", color: "var(--tema-titulo, #0b3c60)", lineHeight: 1.35 },
  subtitulo: { margin: "0.2rem 0 0", fontSize: "0.82rem", color: "#5b6472" },
  buscador: {
    width: "100%",
    boxSizing: "border-box",
    padding: "0.45rem 0.7rem",
    border: "1px solid #d3d9df",
    borderRadius: 8,
    fontFamily: "inherit",
    fontSize: "0.85rem",
    marginBottom: "0.7rem",
  },
  tablaWrap: { border: "1px solid #e2e6ea", borderRadius: 10, maxHeight: "42vh", overflowY: "auto" },
  tabla: { width: "100%", borderCollapse: "collapse", fontSize: "0.86rem", color: "var(--tema-titulo, #0b3c60)" },
  th: {
    padding: "0.5rem 0.7rem",
    background: "#eef1f3",
    fontSize: "0.72rem",
    fontWeight: 700,
    textAlign: "left",
    whiteSpace: "nowrap",
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
  fila: { borderTop: "1px solid #eef1f3" },
  td: { padding: "0.55rem 0.7rem", verticalAlign: "middle" },
  pastilla: {
    display: "inline-block",
    background: "#d7e8f7",
    color: "#1d5fa8",
    borderRadius: 999,
    padding: "0.1rem 0.65rem",
    fontSize: "0.8rem",
    fontWeight: 700,
  },
  botonEsActivo: {
    background: "#fff",
    color: "var(--tema-titulo, #0b3c60)",
    border: "1px solid #d3d9df",
    borderRadius: 999,
    padding: "0.3rem 0.75rem",
    fontSize: "0.76rem",
    fontWeight: 600,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  aviso: {
    background: "#f2e3d1",
    color: "#7a4a17",
    borderRadius: 10,
    padding: "0.7rem 0.85rem",
    fontSize: "0.83rem",
    lineHeight: 1.45,
    margin: "1rem 0 1.2rem",
  },
  pie: { display: "flex", gap: "0.6rem", justifyContent: "flex-end" },
  botonCancelar: {
    background: "#fff",
    color: "var(--tema-titulo, #0b3c60)",
    border: "1px solid #d3d9df",
    borderRadius: 8,
    padding: "0.55rem 1.1rem",
    fontSize: "0.88rem",
    fontWeight: 600,
    cursor: "pointer",
  },
  botonConfirmar: {
    background: "#2f7a54",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "0.55rem 1.2rem",
    fontSize: "0.88rem",
    fontWeight: 700,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
};

export default ConfirmarNoActivoModal;
